module.exports = __webpack_public_path__ + "img/queue.c5e49063.svg";